<div
  class="h-screen w-screen absolute left-0 top-0 flex align-items-center justify-content-center"
>
  @if (loading | async) {
    <p-progressSpinner />
  }
</div>
<!-- Body Content-->
<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-4">
  <div class="flex align-items-center justify-content-between">
    <div>
      <h1
        class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1"
      >
        Settlement
      </h1>
      <app-breadcrumb />
    </div>
    <div>
      <p-button
        icon="fa fa-download"
        styleClass="md:hidden"
        [loading]="btnLoading.value"
        (onClick)="downloadALLData()"
      />
      <p-button
        icon="fa fa-download"
        label="Download all settlements"
        [loading]="btnLoading.value"
        (onClick)="downloadALLData()"
        styleClass="hidden md:inline-flex text-sm"
      />
    </div>
  </div>
  @if (isPayEngine) {
    <div id="hidPayEng"></div>
  }
  @if (isEzypay) {
    <ezypay-settlement (UpdateBtnClickedEvent)="downloadCompleteEvent($event)" [downloadBtnClicked]="downloadBtnClicked.value" [tenantId]="tenantId" />
  }
</div>
<!-- Body Content-->
